import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface DescriptionItem {
  label: string
  value: ReactNode
  /** Mono value — doc numbers, dates, amounts. */
  mono?: boolean
}

const COLUMNS = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
} as const

/**
 * Label/value facts grid (detail-page meta, totals ribbons): dt micro-label
 * over a dd body value; single column below `sm`, `columns` across above it.
 */
export function DescriptionList({
  items,
  columns = 3,
  className,
}: {
  items: DescriptionItem[]
  columns?: keyof typeof COLUMNS
  className?: string
}) {
  return (
    <dl className={cn('grid gap-x-8 gap-y-3', COLUMNS[columns], className)}>
      {items.map((item) => (
        <div key={item.label}>
          <dt className="micro-label">{item.label}</dt>
          <dd
            className={
              item.mono ? 'mt-0.5 font-mono text-[0.8125rem] text-ink' : 'mt-0.5 text-sm text-ink'
            }
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
